import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as dialogActions from '../../../store/dialog/dialogActions';
import * as adminActions from '../../../store/admin/adminActions';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteTransferAgent = (props) => {
    const { dialogActions, adminActions, id } = props;

    /* Build a "delete" callback method. */
    const handleDelete = () => {
        adminActions.deleteTransferAgent(id);
    };

    return (
        <Tooltip title="Delete">
            <IconButton
                color="secondary"
                size="small"
                onClick={() =>
                    dialogActions.openDialog(
                        'Delete a transfer agent',
                        'Are you sure you want to delete this transfer agent?',
                        handleDelete,
                        'Cancel',
                        'Delete'
                    )
                }
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        dialogActions: bindActionCreators(dialogActions, dispatch),
        adminActions: bindActionCreators(adminActions, dispatch),
    };
};

DeleteTransferAgent.propTypes = {
    id: PropTypes.number,
};

export default connect(null, mapDispatchToProps)(DeleteTransferAgent);
